import { gql, TypedDocumentNode } from "@apollo/client";
import { TEMPLATE_GROUP_FIELDS } from "@graphql/fragments/templateGroup";

import {
  CreateTemplateGroupMutation,
  CreateTemplateGroupMutationVariables,
  UpdateTemplateGroupMutation,
  UpdateTemplateGroupMutationVariables,
  DeleteTemplateGroupMutation,
  DeleteTemplateGroupMutationVariables,
} from "./TemplateGroups.generated";

export const CREATE_TEMPLATE_GROUP: TypedDocumentNode<
  CreateTemplateGroupMutation,
  CreateTemplateGroupMutationVariables
> = gql`
  ${TEMPLATE_GROUP_FIELDS}
  mutation CreateTemplateGroup(
    $name: String!
    $templateUuids: [String!]!
    $sharingType: SharingTypeEnum
  ) {
    createTemplateGroup(
      name: $name
      templateUuids: $templateUuids
      sharingType: $sharingType
    ) {
      ok
      templateGroup {
        ...TemplateGroupFields
      }
    }
  }
`;

export const UPDATE_TEMPLATE_GROUP: TypedDocumentNode<
  UpdateTemplateGroupMutation,
  UpdateTemplateGroupMutationVariables
> = gql`
  ${TEMPLATE_GROUP_FIELDS}
  mutation UpdateTemplateGroup(
    $groupUuid: String!
    $name: String
    $templateUuids: [String!]
    $sharingType: SharingTypeEnum
  ) {
    updateTemplateGroup(
      groupUuid: $groupUuid
      name: $name
      templateUuids: $templateUuids
      sharingType: $sharingType
    ) {
      ok
      templateGroup {
        ...TemplateGroupFields
      }
    }
  }
`;

export const DELETE_TEMPLATE_GROUP: TypedDocumentNode<
  DeleteTemplateGroupMutation,
  DeleteTemplateGroupMutationVariables
> = gql`
  mutation DeleteTemplateGroup($groupUuid: String!) {
    deleteTemplateGroup(groupUuid: $groupUuid) {
      ok
    }
  }
`;
